import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@fmnts/i18n';
import { DeclarativeFieldComponent } from './components/declarative-field.component';
import { DeclarativeFieldsetComponent } from './components/declarative-fieldset.component';
import { DeclarativeFormComponent } from './components/declarative-form.component';
import { ErrorMessagePipe } from './pipes/error-message.pipe';

@NgModule({
  declarations: [
    DeclarativeFieldComponent,
    DeclarativeFieldsetComponent,
    DeclarativeFormComponent,
  ],
  exports: [
    ErrorMessagePipe,
    DeclarativeFieldComponent,
    DeclarativeFieldsetComponent,
    DeclarativeFormComponent,
  ],
  imports: [AsyncPipe, ErrorMessagePipe, I18nModule, ReactiveFormsModule],
})
export class DeclarativeFormsModule {}
